export default __webpack_public_path__ + "static/logo-black-24950c1e29ea19be03bdc7addf200309.svg";